export default __webpack_public_path__ + "static/media/controlChevronForward24.78b2a85b.svg";